import * as api from '../../api/index'
import * as endpoints from '../../api/endpoints'
import * as types from '../../api/../mutation-types'

const actions = {
    //SmStocks
    getSmStocks({commit}, payload) {
          return api.fetch(endpoints.SM_STOCKS, payload, commit, (response) => {
            commit(types.SET_SM_STOCKS, response.data.data);
              commit("common/"+types.SET_PAGINATION, response.data.pagination, { root: true });
          });
    },
    getSmStock({commit}, payload) {
      return api.fetch(endpoints.SM_STOCKS+'/'+payload.uuid, payload, commit,  (response) => {
        commit(types.SET_SM_STOCK, response.data);
      });
    },
    createSmStock({commit}, payload) {
      return api.post(endpoints.SM_STOCKS, payload,  commit,(response) => {
        commit(types.SET_SM_STOCK, response.data);
      });
    },
    updateSmStock({commit}, payload) {
      return api.put(endpoints.SM_STOCKS+'/'+payload.uuid, payload, commit, (response) => {
        commit(types.SET_SM_STOCK, response.data);
      })
    },
    deleteSmStock({commit}, payload) {
      return api.remove(endpoints.SM_STOCKS+'/'+payload.uuid, payload,  commit,(response) => {
        commit(types.SET_SM_STOCK, response.data);
      })
    },
    getSmStockProductInfo({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_PRODUCT_INFO+'/'+payload.product_uuid,
        payload, commit, (response) => {
        commit(types.SET_SM_STOCK_PRODUCT_INFO, response.data);
      });
    },
    getSmStockProductHistory({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_PRODUCT_HISTORY, payload, commit, (response) => {
      });
    },
    getSmStockMovementItemsAvailable({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_MOVEMENT_ITEMS_AVAILABLE, payload, commit, (response) => {
      });
    },
    getSmStockMovementItemsAvailableSum({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_MOVEMENT_ITEMS_AVAILABLE_SUM, payload, commit, (response) => {
      });
    },
    getSmStockMovementItemHistory({commit}, payload) {
      return api.fetch(`${endpoints.SM_STOCK_MOVEMENT_ITEM_HISTORY}/${payload.uuid}/history`, payload, commit, (response) => {
      });
    },
    getSmStockMovementItemHistorySum({commit}, payload) {
      return api.fetch(endpoints.SM_STOCK_MOVEMENT_ITEM_HISTORY_SUM, payload, commit, (response) => {
      });
    },
    getSmMachineConsumHistory({commit}, payload) {
        return api.fetch(endpoints.SM_MACHINE_CONSUM_HISTORY, payload, commit, (response) => {
        });
    },
}

export default actions;
